import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';
import './Homepage.css';
import logoDark from './assets/airplane-dark.png';
import logoLight from './assets/airplane-light.png';
import logoBlue from './assets/airplane-blue.png';
import backgroundDark from './assets/background-dark.png';
import backgroundLight from './assets/background-light.png';
import backgroundBlue from './assets/background-blue.png';
import mostbetLogo from './casino_img/mostbet.jpg';
import pinupLogo from './casino_img/pinup.jpg';
import x1betLogo from './casino_img/1xbet.jpg';
import win1Logo from './casino_img/1win.jpg';
import betonredLogo from './casino_img/betonred.jpg';
import melbetLogo from './casino_img/melbet.jpg';
import sloticaLogo from './casino_img/slotica.jpg';
import vavadaLogo from './casino_img/vavada.jpg';
import rabbetLogo from './casino_img/4rabet.jpg';

const translations = {
  en: {
    title: "Predict Aviator",
    selectOffer: "Select offer",
    selectStyle: "Select style:",
    selectLanguage: "Select language:"
  },
  es: {
    title: "Predict Aviator",
    selectOffer: "Oferta",
    selectStyle: "Seleccionar estilo:",
    selectLanguage: "Seleccionar idioma:"
  },
  ru: {
    title: "Predict Aviator",
    selectOffer: "Выбери казино",
    selectStyle: "Стиль:",
    selectLanguage: "Язык:"
  }
};

const HomePage = () => {
  const [selectedStyle, setSelectedStyle] = useState('dark');
  const [selectedLanguage, setSelectedLanguage] = useState('en');
  const [inputText, setInputText] = useState('');
  const navigate = useNavigate();

  const handleStyleChange = (e) => {
    setSelectedStyle(e.target.value);
  };

  const handleLanguageChange = (e) => {
    setSelectedLanguage(e.target.value);
  };

  const handleInputChange = (e) => {
    setInputText(e.target.value);
  };

  const handleStartGame = () => {
    if (selectedStyle === 'old-dark') {
      navigate('/old-dark', { state: { inputText, style: selectedStyle, language: selectedLanguage } });
    } else {
      navigate('/game', { state: { inputText, style: selectedStyle, language: selectedLanguage } });
    }
  };

  let backgroundImage, logo, textColor;
  switch (selectedStyle) {
    case 'light':
      backgroundImage = backgroundLight;
      logo = logoLight;
      textColor = 'black';
      break;
    case 'blue':
      backgroundImage = backgroundBlue;
      logo = logoBlue;
      textColor = 'white';
      break;
    case 'old-dark':
      backgroundImage = backgroundDark;
      logo = logoDark;
      textColor = 'white';
      break;
    default:
      backgroundImage = backgroundDark;
      logo = logoDark;
      textColor = 'white';
      break;
  }

  const t = translations[selectedLanguage];

  return (
    <div className="home-container" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <img src={logo} alt="Airplane" className="home-airplane-logo" />
      <div className="casino-selection-block">
        <h1 style={{ color: textColor }} className="home-title">{t.selectOffer}</h1>
        <div className="casino-logos">
          <img src={mostbetLogo} alt="Mostbet" onClick={handleStartGame} />
          <img src={pinupLogo} alt="Pin-up" onClick={handleStartGame} />
          <img src={x1betLogo} alt="1XBET" onClick={handleStartGame} />
          <img src={win1Logo} alt="1win" onClick={handleStartGame} />
          <img src={betonredLogo} alt="Bet on Red" onClick={handleStartGame} />
          <img src={melbetLogo} alt="Melbet" onClick={handleStartGame} />
          <img src={sloticaLogo} alt="Slottica" onClick={handleStartGame} />
          <img src={vavadaLogo} alt="Vavada" onClick={handleStartGame} />
          <img src={rabbetLogo} alt="4rabet" onClick={handleStartGame} />
        </div>
      </div>
      <div className="selection-block">
        <label>
          <select value={selectedStyle} onChange={handleStyleChange} className="styled-select">
            <option value="dark">Dark (default)</option>
            <option value="light">Light</option>
            <option value="blue">Blue</option>
            <option value="old-dark">Old (dark)</option>
          </select>
        </label>
        <label>
          <select value={selectedLanguage} onChange={handleLanguageChange} className="styled-select">
            <option value="en">English</option>
            <option value="ru">Русский</option>
            <option value="es">Español</option>
          </select>
        </label>
      </div>
      <label>
          <input type="text" value={inputText} onChange={handleInputChange} placeholder="text (max.15 symb.)" className="styled-input" />
        </label>
    </div>
  );
};

export default HomePage;
